import ROUTES from "../routes";
import { RouteConfig } from "vue-router";

export const WorkspacesRoutes: Array<RouteConfig> = [
  {
    path: "/workspaces",
    component: () =>
      import(
        /* webpackChunkName: 'workspaces' */
        /* webpackPrefetch: true */
        "../../view/wrappers/workspaces.vue"
      ),
    name: ROUTES.WORKSPACES,
  },
];
